import { defineFurniture } from './types.js';
import type { FurnitureDef } from './types.js';

/**
 * Arcade cabinets and mini-game props (category 'arcade', interaction
 * { type: 'arcade', game }). Every cabinet works in any room, so players can
 * run an arcade at home. Owned by the arcade feature.
 */
export const ARCADE_FURNITURE: Record<string, FurnitureDef> = {
  ...defineFurniture('arcade', {
    arcade_kopi_catch: {
      label: 'Kopi Catch Machine',
      description: 'Catch the kopi, dodge the durians. Click to play!',
      price: 1200,
      solid: true,
      height: 1.8,
      interaction: { type: 'arcade', game: 'kopi_catch' },
    },
    arcade_mrt_dash: {
      label: 'MRT Dash Machine',
      description: 'An endless run to catch the last train. Click to play!',
      price: 1500,
      solid: true,
      height: 1.8,
      interaction: { type: 'arcade', game: 'mrt_dash' },
    },
    arcade_kueh_stack: {
      label: 'Kueh Stack Machine',
      description: 'Stack the tallest kueh lapis. Click to play!',
      price: 1000,
      solid: true,
      height: 1.8,
      interaction: { type: 'arcade', game: 'kueh_stack' },
    },
    arcade_chope: {
      label: 'Chope! Machine',
      description: 'Chope a table before the aunties do. Click to play!',
      price: 1300,
      solid: true,
      height: 1.8,
      interaction: { type: 'arcade', game: 'chope' },
    },
    dragon_boat: {
      label: 'Dragon Boat',
      description: 'Race 2-4 kakis to the drum beat. Click to join the next race!',
      price: 2000,
      solid: true,
      height: 0.9,
      interaction: { type: 'arcade', game: 'dragon_boat' },
    },
  }),
  ...defineFurniture('fun', {
    popcorn_cart: {
      label: 'Popcorn Cart',
      description: 'Caramel or salted? Both, obviously.',
      price: 450,
      solid: true,
      height: 1.6,
    },
    balloon_stand: {
      label: 'Balloon Stand',
      description: 'A bunch of bright balloons. Try not to let go.',
      price: 300,
      solid: true,
      height: 2.2,
    },
    carousel_horse: {
      label: 'Carousel Horse',
      description: 'A painted pony on a brass pole. Hop on!',
      price: 600,
      solid: false,
      seat: 'facing',
      height: 0.7,
    },
    string_lights: {
      label: 'Pasar Malam Lights',
      description: 'A pole strung with night-market bulbs.',
      price: 250,
      solid: true,
      height: 2.4,
    },
  }),
  ...defineFurniture('decor', {
    sand_mat: {
      label: 'Beach Sand',
      description: 'A patch of East Coast sand. Walk right over it.',
      price: 60,
      solid: false,
      height: 0,
    },
    sea_water: {
      label: 'Sea Water',
      description: 'Sparkling sea. Too deep to wade into.',
      price: 80,
      solid: true,
      height: 0,
    },
  }),
};
